import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

class Faq extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    
    this.element = element
    this.el = $(element)
    this.index = 0
    this.current = 0


    this.ref = {
      row: []  
    }

  }

  mount() {

     _each(this.ref.row, (item) => {



         $(item).on('click', (e) => {
           // console.log(e);
             $('.question--visible').not(item).removeClass('question--visible')
             $(item).toggleClass('question--visible')
         })
     })


      
}





resize(){
  
}

  unmount() {


    _each(this.ref.row, (item) => {

      $(item).off('click')
    })


  }


}

module.exports = Faq
